<template>
  <section>
    <b-row>
      <b-col md="12">
        <h2>Encuestas dinámicas <span v-if="$auth.can('agregar_dinamicas')">
            <b-button size="sm" variant="info" @click.prevent="agregar"><b-icon icon="plus-square"></b-icon> Agregar</b-button>
          </span></h2>
      </b-col>
    </b-row>
    <b-form ref="filtros" @submit.prevent="cargarDinamicas">
      <b-form-row>
        <b-col sm="6">
          <b-form-group label="Nombre:" label-for="input-filtro-nombre">
            <b-form-input id="input-filtro-nombre" type="text" v-model="filtros.nombre"></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-button variant="primary" type="submit">Filtrar</b-button>
        </b-col>
      </b-form-row>
    </b-form>
    <b-row>
      <b-col md="12">
        <b-table responsive striped hover :items="dinamicas" :fields="campos">
          <template #cell(tipo)=row>
            {{ nombreTipo(row.item) }}
          </template>
          <template #cell(enlace)=row>
            <a :href="link(row.item)" target="_blank">{{ link(row.item) }}</a>
          </template>
          <template #cell(visitante)=row>
            <a :href="linkVisitante(row.item)" target="_blank">{{ linkVisitante(row.item) }}</a>
          </template>
          <template #cell(acciones)="row">
            <b-link :to="{ name: 'dinamicas.grupos', params: { id: row.item.id }}" v-if="$auth.can('editar_dinamicas')">Grupos</b-link>
            <b-link :to="{ name: 'dinamicas.preguntas', params: { id: row.item.id }}" v-if="$auth.can('editar_dinamicas')">Preguntas</b-link>
            <b-link :to="{ name: 'dinamicas.respuestas', params: { id: row.item.id }}" v-if="$auth.can('exportar_encuestas')">Respuestas</b-link>
            <b-link href="" @click.prevent="editar(row.item)" v-if="$auth.can('editar_dinamicas')">Editar</b-link>
            <b-link href="" @click.prevent="clonar(row.item)" v-if="$auth.can('agregar_dinamicas')">Clonar</b-link>
          </template>
        </b-table>
        <b-pagination v-model="page" :total-rows="count" :per-page="limit" aria-controls="my-table" align="center"></b-pagination>
      </b-col>
    </b-row>
    <b-modal v-model="mainModal" size="lg" no-close-on-backdrop>
      <b-form ref="mainForm" @submit.prevent="guardar">
        <b-form-group label="Nombre:" label-for="input-nombre" :invalid-feedback="errores.nombre">
          <b-form-input id="input-nombre" v-model="dinamica.nombre" :state="$empty(errores.nombre)" trim></b-form-input>
        </b-form-group>
        <b-form-group label="Tipo:" label-for="select-tipo-id" :invalid-feedback="errores.tipo">
          <b-form-select id="select-tipo-id" v-model="dinamica.tipo" :state="$empty(errores.tipo)" :disabled="Boolean(id)" trim>
            <b-select-option :value="null">Seleccione uno</b-select-option>
            <b-select-option v-for="tipo in tipos" :key="tipo.key" :value="tipo.key">{{ tipo.value }}</b-select-option>
          </b-form-select>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="submit()">
          OK
        </b-button>
        <b-button variant="danger" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="cloneModal" size="lg" no-close-on-backdrop>
      <b-form ref="cloneForm" @submit.prevent="cloneGuardar">
        <b-form-group label="Nombre:" label-for="input-nombre" :invalid-feedback="cloneErrores.nombre">
          <b-form-input id="input-nombre" v-model="clone.nombre" :state="$empty(cloneErrores.nombre)" trim></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="cloneSubmit()">
          OK
        </b-button>
        <b-button variant="danger" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>
  </section>
</template>

<script lang="ts">
import axios from 'axios'
import {Vue, Component, Watch} from 'vue-property-decorator'

import {url} from '../../../services/url_service'

@Component
export default class Dinamicas extends Vue {
  public page: number = 1
  public limit: number = 20
  public count: number = 0
  public mainModal: boolean = false
  public cloneModal: boolean = false
  public errores: any = {}
  public cloneErrores: any = {}
  public id?: number = null
  public dinamica: any = {}
  public clone: any = {}
  public filtros: any = {}
  public dinamicas: any = []
  public tipos: any = []
  public campos: any = [
    {
      key: 'nombre',
    },
    {
      key: 'tipo',
    },
    {
      key: 'enlace',
    },
    {
      key: 'visitante',
    },
    {
      key: 'estado'
    },
    {
      key: 'acciones',
    },
  ]
  public nombreTipo(pregunta) {
    return (this.tipos.find(function (tipo) {
      return tipo.key === pregunta.tipo
    }))?.value
  }
  public async cargarDinamicas() {
    let response = await axios.get(url.create('/internal/dinamicas'), {
      params: {
        filtros: this.filtros,
        limit: this.limit,
        page: this.page,
      },
    })
    this.dinamicas = response.data.data
    this.count = response.data.count
  }
  public async cargarTipos() {
    let response = await axios.get(url.create('/public/enums/tipos_encuesta'))
    this.tipos = response.data
  }
  public async agregar() {
    this.errores = {}
    this.mainModal = true
    this.id = null
    this.dinamica = {
      tipo: null,
    }
  }
  public async editar(dinamica) {
    this.errores = {}
    this.mainModal = true
    this.id = dinamica.id
    this.dinamica = {
      nombre: dinamica.nombre,
      tipo: dinamica.tipo,
    }
  }
  public async clonar(dinamica) {
    this.errores = {}
    this.cloneModal = true
    this.clone = {
      id: dinamica.id,
      nombre: `${dinamica.nombre} (CLONE)`,
    }
  }

  public submit() {
    (this.$refs.mainForm as Element).dispatchEvent(new window.Event('submit'))
  }

  public cloneSubmit() {
    (this.$refs.cloneForm as Element).dispatchEvent(new window.Event('submit'))
  }

  public async guardar() {
    try {
      this.errores = {}
      let promise = this.id
        ? axios.put(url.create(`/internal/dinamicas/${this.id}`), this.dinamica)
        : axios.post(url.create(`/internal/dinamicas`), this.dinamica)
      let response = await promise
      this.mainModal = false
      this.cargarDinamicas()
    } catch (ex) {
      this.errores = ex.response.data
    }
  }

  public async cloneGuardar() {
    try {
      this.errores = {}
      let promise = axios.post(url.create(`/internal/dinamicas/clone`), this.clone)
      let response = await promise
      this.cloneModal = false
      this.cargarDinamicas()
    } catch (ex) {
      this.cloneErrores = ex.response.data
    }
  }

  public link(dinamica) {
    return `${url.base}#/dinamica/${dinamica.id}`
  }

  public linkVisitante(dinamica) {
    return `${url.base}visitante?encuesta=${dinamica.id}`
  }

  @Watch('page')
  public pageChange(value) {
    this.cargarDinamicas()
  }
  created() {
    this.cargarDinamicas()
    this.cargarTipos()
  }
}
</script>

<style lang="scss">
</style>